<template>
  <div
    :class="[selected ? 'selected-conv' : '']"
    class="conversation-card"
    @click="selectConversation"
  >
    <div
      v-if="conversation"
      class="conversation-card-body"
      v-bind:class="{ 'has-unread': hasUnread }"
    >
      <span class="read-indicator">
        <v-icon size="28">mdi-circle-medium</v-icon>
      </span>

      <span class="conversation-date">{{ updatedDate }}</span>

      <b>{{ conversation.friendlyName }}</b>
      <div class="excerpt">{{ excerpt }}&nbsp;</div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import { hasUnread, storedExcerptText } from "@/helpers/chat";

export default Vue.extend({
  name: "ChatConversationCard",
  // refreshedExcerpt is set by the parent when the reconciler repaired this conversation, and is
  // null the rest of the time -- the normal case reads the excerpt the webhook stamped.
  props: ["conversation", "selected", "refreshedExcerpt"],
  data() {
    return {
      channel: null, // see watch below
      momentCalendarFormat: {
        lastDay: "[Yesterday]",
        sameDay: "LT",
        nextDay: "[Tomorrow]",
        lastWeek: "M/D/YY",
        nextWeek: "[Next] dddd",
        sameElse: "M/D/YY"
      }
    };
  },

  async mounted() {
    this.channel = this.conversation;
    //console.log("ChatConversationCard: ADDING channel updated listener")
    this.conversation.on("updated", this.conversationUpdated);
  },
  beforeDestroy() {
    //console.log("ChatConversationCard: REMOVING channel updated listener")
    this.conversation.off("updated", this.conversationUpdated);
  },
  computed: {
    updatedDate() {
      if (!this.conversation) return null;
      const dt = this.conversation.lastMessage
        ? this.conversation.lastMessage.dateCreated
        : this.conversation.dateUpdated
        ? this.conversation.dateUpdated
        : this.conversation.dateCreated;
      return dt ? moment(dt).calendar(this.momentCalendarFormat) : null;
    },
    hasUnread() {
      return this.channel ? hasUnread(this.channel) : false;
    },
    excerpt() {
      // The webhook stamps this onto the conversation attributes, and Twilio pushes the change to
      // connected clients, so no fetch is needed to stay current. refreshedExcerpt only has a value
      // when the reconciler had to repair one the webhook missed.
      if (this.refreshedExcerpt && this.refreshedExcerpt.text) {
        return this.refreshedExcerpt.text;
      }
      return storedExcerptText(this.channel || this.conversation);
    }
  },
  methods: {
    conversationUpdated({ conversation }) {
      // Reassigning channel is what re-renders: excerpt and hasUnread both read from it, and the SDK
      // mutates conversation objects in place so the reference alone never signals a change.
      this.channel = conversation;
    },
    selectConversation() {
      this.conversation.setAllMessagesRead();
      this.$emit("selectConversation", this.conversation);
    }
  }
});
</script>
<style scoped>
.conversation-card {
  color: black;
  cursor: pointer;
  border-bottom: 1px solid #ddd;
  min-height: 79px;
  font-size: 15px;
}

.conversation-card-body {
  padding: 20px 20px 20px 40px;
}

.conversation-date {
  color: dodgerblue;
  float: right;
  font-size: 12px;
}

.selected-conv,
.selected-conv .conversation-date {
  color: white;
}

.selected-conv {
  background-color: rgb(0, 150, 255);
}

.excerpt {
  max-height: 38px;
  overflow: hidden;
  font-size: 13px;
  text-overflow: ellipsis;
}

.read-indicator {
  color: transparent;
  float: left;
  margin-left: -30px;
  margin-top: -5px;
}
.read-indicator .v-icon {
  visibility: hidden;
}

.read-indicator .v-icon {
  color: dodgerblue;
}
.has-unread .read-indicator .v-icon {
  visibility: visible;
}
</style>
